import Swiper  from "swiper/bundle";

const buildSwiperSix = (sliderElm, index) => {
  const uniqueClass = `steps-slider-${index}`;
  sliderElm.classList.add(uniqueClass);

  // Select the navigation buttons within this specific slider element
  const nextButton = sliderElm.querySelector('.fs-slider-button-next');
  const prevButton = sliderElm.querySelector('.fs-slider-button-prev');

  // Add unique classes to the next and prev buttons
  if (nextButton) {
    nextButton.classList.add(`${uniqueClass}-next`);
  }

  if (prevButton) {
    prevButton.classList.add(`${uniqueClass}-prev`);
  }

  return new Swiper(`.${uniqueClass}`, {
    autoplay:false,
    loop:false,
    slidesPerGroup:1,
    breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 24,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 28,
        },
        1440: {
            slidesPerView: 4,
            spaceBetween: 28,
        },
        1500: {
            slidesPerView: 4.3,
            spaceBetween: 28,
        },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: `.${uniqueClass}-next`,
      prevEl: `.${uniqueClass}-prev`,
    },
  });
};

document.addEventListener('DOMContentLoaded', function () {
  // Get all of the swipers on the page
  const stepsSlider = document.querySelectorAll(".steps-slider");

  // Loop over all of the fetched sliders and apply Swiper on each one.
  stepsSlider.forEach((slider, i) => buildSwiperSix(slider, i));
});